import { render, staticRenderFns } from "./audiences-table.vue?vue&type=template&id=1cc78138&scoped=true"
import script from "./audiences-table.vue?vue&type=script&lang=js"
export * from "./audiences-table.vue?vue&type=script&lang=js"
import style0 from "./audiences-table.vue?vue&type=style&index=0&id=1cc78138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc78138",
  null
  
)

export default component.exports